/**
 * The native AppIcon plugin (AppIconPlugin.swift), registered once so
 * Settings and App.js share the same instance.
 */
import { registerPlugin } from '@capacitor/core';

export const AppIcon = registerPlugin('AppIcon');
